import { button, ButtonIcon } from "./button";
import LogoDalmaBlue from "./logo_dalma_blue.svg";
import { BOOK_MEETING } from "src/config";
import { Location } from "src/utils/url-builder";
import { Link } from "react-router-dom";
import { theme, styled, css } from "src/style/theme";

type Props = {
  hideLink?: boolean;
  hideLogo?: boolean;
  backLink?: Location;
};

const Content = styled("div", {
  width: "100%",
  padding: "0px 16px 0px 25px",
  display: "flex",
  height: 64,
  justifyContent: "space-between",
  position: "sticky",
  top: 0,
  zIndex: 1,
  background: theme.colors.electric,

  "@bp1": {
    boxShadow: `0 0 2px ${theme.colors.gray400}`,
    height: 72,
  },
});

const Logo = styled("img", {
  width: "132px",
});

const Wrapper = styled("div", {
  display: "flex",
  alignItems: "center",
});

const goBack = css({
  display: "flex",
  alignItems: "center",
  width: 50,
  justifyContent: "center",

  "&a": {
    cursor: "pointer",
  },

  "@bp1": {
    display: "none",
  },
});

export const Header = ({ backLink, hideLink, hideLogo }: Props) => {
  return (
    <Content>
      {backLink ? (
        <Link className={goBack()} to={backLink}>
          <svg
            width="16"
            height="18"
            viewBox="0 0 16 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.6667 7.66669H4.54667L8.94667 3.28002C9.19774 3.02895 9.33879 2.68843 9.33879 2.33336C9.33879 1.97829 9.19774 1.63776 8.94667 1.38669C8.6956 1.13562 8.35507 0.994568 8 0.994568C7.64494 0.994568 7.30441 1.13562 7.05334 1.38669L0.386671 8.05336C0.265283 8.18016 0.17013 8.32969 0.106671 8.49336C-0.0266865 8.81797 -0.0266865 9.18207 0.106671 9.50669C0.17013 9.67036 0.265283 9.81988 0.386671 9.94669L7.05334 16.6134C7.17729 16.7383 7.32476 16.8375 7.48724 16.9052C7.64971 16.9729 7.82399 17.0078 8 17.0078C8.17602 17.0078 8.3503 16.9729 8.51277 16.9052C8.67525 16.8375 8.82272 16.7383 8.94667 16.6134C9.07164 16.4894 9.17083 16.3419 9.23853 16.1795C9.30622 16.017 9.34107 15.8427 9.34107 15.6667C9.34107 15.4907 9.30622 15.3164 9.23853 15.1539C9.17083 14.9914 9.07164 14.844 8.94667 14.72L4.54667 10.3334H14.6667C15.0203 10.3334 15.3594 10.1929 15.6095 9.94283C15.8595 9.69278 16 9.35365 16 9.00002C16 8.6464 15.8595 8.30726 15.6095 8.05721C15.3594 7.80717 15.0203 7.66669 14.6667 7.66669Z"
              fill="white"
            />
          </svg>
        </Link>
      ) : (
        <div className={goBack()} />
      )}
      <Wrapper>{!hideLogo && <Logo src={LogoDalmaBlue} />}</Wrapper>
      {!hideLink && (
        <div style={{ display: "flex", alignItems: "center" }}>
          <a
            href={BOOK_MEETING}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className={button({
              variant: "primary",
              smallPadding: true,
            })}
            style={{
              // @ts-ignore HACK
              "---color": "rgba(0,0,0,0.2)",
              height: 40,
              borderWidth: 0,
            }}
          >
            <ButtonIcon
              header
              icon={
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.96 7.66668C11.8133 7.66668 11.66 7.62001 11.5133 7.58668C11.2163 7.52123 10.9245 7.43434 10.64 7.32668C10.3307 7.21417 9.99077 7.22001 9.68555 7.34309C9.38032 7.46616 9.1314 7.69777 8.98667 7.99335L8.84001 8.29335C8.19067 7.93213 7.594 7.4835 7.06667 6.96001C6.54319 6.43269 6.09455 5.83601 5.73334 5.18668L6.01334 5.00001C6.30892 4.85529 6.54053 4.60637 6.6636 4.30114C6.78668 3.99592 6.79252 3.65596 6.68001 3.34668C6.57415 3.06163 6.4873 2.76988 6.42001 2.47335C6.38667 2.32668 6.36001 2.17335 6.34001 2.02001C6.25905 1.55043 6.01309 1.12518 5.64642 0.82084C5.27975 0.516505 4.81647 0.353086 4.34001 0.360014H2.34001C2.05269 0.357316 1.76817 0.416556 1.50581 0.533701C1.24345 0.650845 1.00941 0.823144 0.819626 1.03887C0.62984 1.25459 0.488763 1.50868 0.405998 1.78382C0.323234 2.05897 0.300726 2.34872 0.340006 2.63335C0.695165 5.42627 1.97069 8.02127 3.96511 10.0084C5.95952 11.9956 8.55915 13.2617 11.3533 13.6067H11.6067C12.0983 13.6074 12.5729 13.427 12.94 13.1C13.1509 12.9114 13.3194 12.6801 13.4343 12.4216C13.5492 12.163 13.608 11.883 13.6067 11.6V9.60001C13.5985 9.13694 13.4299 8.69105 13.1296 8.33846C12.8293 7.98587 12.4159 7.74843 11.96 7.66668ZM12.2933 11.6667C12.2932 11.7613 12.2729 11.8549 12.2339 11.9411C12.1948 12.0273 12.1378 12.1042 12.0667 12.1667C11.9924 12.2314 11.9053 12.2796 11.8111 12.3083C11.7169 12.3371 11.6177 12.3456 11.52 12.3333C9.02327 12.0132 6.70416 10.871 4.92848 9.08687C3.1528 7.30274 2.02161 4.97824 1.71334 2.48001C1.70273 2.38236 1.71203 2.28357 1.74067 2.18961C1.76932 2.09565 1.81672 2.00847 1.88001 1.93335C1.94248 1.86223 2.01938 1.80524 2.10559 1.76616C2.1918 1.72708 2.28535 1.7068 2.38001 1.70668H4.38001C4.53504 1.70323 4.68642 1.75393 4.8081 1.85006C4.92978 1.94619 5.01415 2.08173 5.04667 2.23335C5.07334 2.41557 5.10667 2.59557 5.14667 2.77335C5.22369 3.12478 5.32618 3.47013 5.45334 3.80668L4.52001 4.24001C4.4402 4.27663 4.36842 4.32864 4.30878 4.39308C4.24913 4.45751 4.20281 4.53309 4.17245 4.61548C4.1421 4.69786 4.12832 4.78543 4.1319 4.87316C4.13549 4.96089 4.15637 5.04704 4.19334 5.12668C5.15281 7.18185 6.80484 8.83388 8.86001 9.79335C9.02231 9.86003 9.20437 9.86003 9.36667 9.79335C9.44981 9.76361 9.52622 9.71765 9.59145 9.65814C9.65669 9.59863 9.70945 9.52675 9.74667 9.44668L10.16 8.51335C10.5047 8.6366 10.8564 8.73901 11.2133 8.82001C11.3911 8.86001 11.5711 8.89335 11.7533 8.92001C11.905 8.95254 12.0405 9.0369 12.1366 9.15858C12.2328 9.28026 12.2835 9.43165 12.28 9.58668L12.2933 11.6667Z"
                    fill="white"
                  />
                </svg>
              }
            >
              Rappelez-moi
            </ButtonIcon>
          </a>
        </div>
      )}
    </Content>
  );
};
